import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import axios from "axios";
import config from "../config/constants";
import NotLoggedIn from "../views/NotLoggedIn.vue";
import LoggedIn from "../views/LoggedIn.vue";
import NotFound from "../views/NotFound.vue";
import Feedback from "../views/Feedback.vue";
import LoginAs from "../views/LoginAs.vue";
import BupaSso from "../views/BupaSso.vue";
import OauthSso from "../views/OauthSso.vue";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TCs from "../pages/TCs";
import TCsSpark from "../pages/TCsSpark.vue";
import ContentSources from "../pages/ContentSources.vue";
import Redirect from "../pages/Redirect";
import OAuthGoogle from "../pages/oauth/google/Authenticate";
import TherapyPortalPage from "@/pages/therapyPortal/TherapyPortalPage.vue";
import TherapySchoolQuestionnaire from "../components/TherapyPortal/TherapySchoolQuestionnaire.vue";
import Info from "../pages/Info"
import Datenschutzrichtlinie from "../pages/Datenschutzrichtlinie"
import Nutzungsbedingungen from "../pages/Nutzungsbedingungen"
import OpenEmailBrowser from "../pages/OpenEmailBrowser.vue";
import Faqs from "../pages/Faqs.vue";
import AccessibilityPolicy from "@/pages/AccessibilityPolicy.vue";
import StripeMobileRedirect from "../pages/StripeMobileRedirect.vue";
import PrivacyPolicyVPC from "@/pages/PrivacyPolicyVPC.vue";
import WelcomeReferral from "@/pages/WelcomeReferral.vue";
import EmergencyServices from "@/pages/EmergencyServices.vue";
import Session from "@/pages/Session.vue";
import VerifyEmail from "@/pages/VerifyEmail.vue";
import GuestJoin from "@/pages/GuestJoin.vue";

Vue.use(VueRouter);

const isConnectedMentalHealth = false;
function getHomePageComponent() {
  return isConnectedMentalHealth ? LoggedIn : LoggedIn;
}
const beforeEnterHandler = function (to, from, next) {
  if (store.getters.user.authenticated) {
    if (store.getters.isSaml) {
      /**
       * Skip TC PP for My Staff Shop(6143)
       */
      if (parseInt(store.getters.user.user_client_id) == 6143) {
        next();
      }
      if (!store.getters.user.user.tc_accepted) {
        next('/terms-and-conditions').catch(() => { });
      };
      if (!store.getters.user.user.pp_accepted) {
        next('/privacy-policy').catch(() => { });
      };
    }
    /**
     * hardcoded homepages per client
     */
    if (to.name === 'home') {
      if (store.getters.skin === 20) {
        next('/digital-gym').catch(() => { })
      }
      switch (parseInt(store.getters.user.user_client_id)) {
        case 3519:
          next('/personal/my-company').catch(() => { })
          break;
        case 5191:
          /**
           * Workhuman
           */
          next('/clinics/digital').catch(() => { })
          break;
        default:
          next()
      }
    }
  }
  next();
}
const routes = [
  {
    path: "/login",
    name: "NotLoggedIn",
    component: NotLoggedIn,
    beforeEnter: (to, from, next) => {
      if (store.getters.subdomain === 'layaeap') {
        store.dispatch('accessCodeLogin', { router: router, accessCode: 'LayaEAP' })
      }
      next();
    }
  },
  {
    path: "/site/loginas",
    name: "loginAs",
    component: LoginAs
  },
  {
    path: '/two-factor',
    name: 'twoFactor',
    component: NotLoggedIn
  },
  {
    path: "/bupa/",
    name: "bupa-sso",
    component: BupaSso
  },
  {
    path: "/sso/",
    name: "sso",
    component: LoginAs
  },
  {
    path: "/oauth/sso",
    name: "oauthSso",
    component: OauthSso,
    beforeEnter: (to, from, next) => {
      if (!store.getters.user.authenticated) {
        store.commit("setPreviousRoute", { path: to.fullPath });
        next("/login");
      } else {
        next();
      }
    }
  },
  { // fix for benenden broken link ....
    path: "/loginas",
    name: "loginAs",
    component: LoginAs
  },
  {
    path: "/verify",
    name: "verifyEmail",
    component: NotLoggedIn
  },
  {
    path: "/reset",
    name: "resetPassword",
    component: NotLoggedIn,
  },
  {
    path: "/forgot",
    name: "forgotPassword",
    component: NotLoggedIn
  },
  {
    path: "/submit-feedback/:token/:type/:lang?",
    name: "Feedback",
    component: Feedback
  },
  {
    // Optional param: index.html strips the token out of the URL before any
    // third-party tag can read it, so by the time the router runs the path is
    // usually bare "/join" and GuestJoin reads the token from memory.
    path: "/join/:token?",
    name: "joinInvite",
    component: GuestJoin
  },
  {
    path: "/",
    name: "home",
    component: getHomePageComponent(),
    beforeEnter: beforeEnterHandler,
  },
  {
    //needed for vodafone
    path: "/site/enterprise-app-validate",
    name: "iosAppDownload",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/wellbeing",
    name: "wellbeing",
    // meta: { title: navItems['wellbeing'] ? navItems['wellbeing'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/wellbeing/articles",
    name: "allArticles",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
    // meta: { title: navItems['wellbeing'] ? navItems['wellbeing'].label : "" },
  },
  {
    path: "/wellbeing/article/:id",
    name: "article",
    // meta: { title: navItems['wellbeing'] ? navItems['wellbeing'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/wellbeing/courses",
    name: "allCourses",
    // meta: { title: navItems['wellbeing'] ? navItems['wellbeing'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/wellbeing/:id",
    name: store.getters.skin === 10 ? "layaCourse" : "course",
    // meta: { title: navItems['wellbeing'] ? navItems['wellbeing'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/be-calm",
    name: "beCalm",
    // meta: { title: navItems['be calm'] ? navItems['be calm'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/be-calm/:id",
    name: "beCalmCourse",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/studio-overview",
    name: "studioOverview",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/wellbeing-studio",
    name: "wellbeingSeries",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/wellbeing-studio/:id",
    name: "virtualEvent",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/wellbeing-studio-test/:id",
    name: "virtualEventTest",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/wellbeing-studio/course/:id",
    name: store.getters.skin === 10 ? "layaCourse" : "wellbeingCourse",
    // meta: { title: navItems['wellbeing'] ? navItems['wellbeing'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/digital-gym",
    name: "digitalGym",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/digital-gym/training-plans/:id",
    name: "trainingPlan",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/digital-gym/:id",
    name: "digitalGymArticle",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/eap",
    name: "eap",
    // meta: { title: navItems['eap'] ? navItems['eap'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/marketplace/events/view-event/:id",
    name: "viewEvent",
    // meta: { title: navItems['events'] ? navItems['events'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/marketplace/events/:page?/:webinar?",
    name: "events",
    // meta: { title: navItems['events'] ? navItems['events'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/digital-clinics",
    name: "digitalClinics",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/mindfulness",
    name: "mindfulness",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  // {
  //   path: "/digital-clinics/bookings",
  //   name: "digitalClinicsBookings",
  //   component: LoggedIn,
  //   beforeEnter: beforeEnterHandler,
  // },
  {
    path: "/whats-happening",
    name: "whatsHappening",
    // meta: { title: navItems['my organisation'] ? navItems['my organisation'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/personal/my-company",
    name: "myOrganisation",
    // meta: { title: navItems['my organisation'] ? navItems['my organisation'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/personal/fitness",
    name: "fitness",
    // meta: { title: navItems['fitness'] ? navItems['fitness'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
    props: true
  },
  {
    path: "/personal/nutrition",
    name: "nutrition",
    // meta: { title: navItems['nutrition'] ? navItems['nutrition'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/recipe",
    name: "recipe",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/personal/metrics",
    name: "metrics",
    // meta: { title: navItems['metrics'] ? navItems['metrics'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/personal/rewards",
    name: "rewards",
    // meta: { title: navItems['rewards'] ? navItems['rewards'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/personal/insights",
    name: "insights",
    // meta: { title: navItems['insights'] ? navItems['insights'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    // V2: one continuous check-in walks every enabled track (no per-track slug)
    path: "/personal/insights/check-in",
    name: "insightsCheckIn",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    // V2: the unified wellbeing report (replaces the per-track results screen)
    path: "/personal/insights/report",
    name: "insightsReport",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  // Legacy V1 per-track URLs → fold into the unified V2 flow.
  // More specific paths first so vue-router matches them before /:slug.
  {
    path: "/personal/insights/check-in/:slug/results",
    redirect: "/personal/insights/report",
  },
  {
    path: "/personal/insights/check-in/:slug/questions",
    redirect: "/personal/insights/check-in",
  },
  {
    path: "/personal/insights/check-in/:slug",
    redirect: "/personal/insights/check-in",
  },
  {
    path: "/wellness-benefits",
    name: "wellnessBenefits",
    // meta: { title: navItems['wellbeing benefits'] ? navItems['wellbeing benefits'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/marketplace/wellness-benefits",
    name: "wellnessBenefitsOld",
    // meta: { title: navItems['wellbeing benefits'] ? navItems['wellbeing benefits'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
    props: { specsavers: true },
  },
  {
    path: "/marketplace/wellbeing-benefits",
    name: "wellbeingBenefits",
    // meta: { title: navItems['wellbeing benefits'] ? navItems['wellbeing benefits'].label : "" },
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/marketplace/wellbeing-benefits/specsavers",
    name: "specsavers",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/marketplace/store",
    name: "fitbit",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/marketplace/confirmation",
    name: "orderConfirmation",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/get-ios-app",
    name: "download",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/faq",
    name: "faq",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/settings",
    name: "settings",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/my-future-wellbeing",
    name: "myFutureWellbeing",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/notification-centre",
    name: "notificationCentre",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "*",
    name: "not-found",
    component: NotFound
  },
  {
    path: "/privacy-policy",
    name: "privacy",
    component: PrivacyPolicy
  },
  {
    path: "/privacy-policy-vpc",
    name: "privacy-policy-vpc",
    component: PrivacyPolicyVPC
  },
  {
    path: "/terms-and-conditions/:slug?",
    name: "TCs",
    component: TCs
  },
  {
    path: "/terms-and-conditions-spark",
    name: "TCsSpark",
    component: TCsSpark
  },
  {
    path: "/emergency-services",
    name: "EmergencyServices",
    component: EmergencyServices
  },
  {
    path: "/content-sources",
    name: "content-sources",
    component: ContentSources
  },
  {
    path: "/redirect/:client",
    name: "Redirect",
    component: Redirect
  },
  // {
  //   path: "/community",
  //   name: "community",
  //   component: LoggedIn,
  // beforeEnter: beforeEnterHandler,
  // },
  // {
  //   path: "/community/post/:id",
  //   name: "communityPost",
  //   component: LoggedIn,
  // beforeEnter: beforeEnterHandler,
  // },
  // {
  //   path: "/community/user/:id",
  //   name: "communityUser",
  //   component: LoggedIn,
  // beforeEnter: beforeEnterHandler,
  // },
  {
    path: "/datenschutzrichtlinie",
    name: "Datenschutzrichtlinie",
    component: Datenschutzrichtlinie
  },
  {
    path: "/nutzungsbedingungen",
    name: "Nutzungsbedingungen",
    component: Nutzungsbedingungen
  },
  // {
  //   path: "/pulse",
  //   name: "pulse",
  //   component: LoggedIn,
  // beforeEnter: beforeEnterHandler,
  // },
  {
    path: "/sound-space",
    name: "soundSpace",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/sound-space/:id",
    name: "podcast",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/total-mental-health",
    name: "totalMentalHealth",
    component: LoggedIn
  },
  {
    path: "/total-mental-health/start",
    name: "totalMentalHealthStart",
    component: LoggedIn
  },
  {
    path: "/total-mental-health/select-coach",
    name: "totalMentalHealthSelectCoach",
    component: LoggedIn,
  },
  {
    path: "/total-mental-health/your-impact",
    name: "totalMentalHealthYourImpact",
    component: LoggedIn,
  },
  {
    path: "/booking-video-room/:booking_id/:tests?",
    name: "bookingVideoRoom",
    component: LoggedIn
  },
  {
    path: "/info/:code",
    name: "info",
    component: Info
  },
  {
    path: "/survey",
    name: "survey",
    component: NotLoggedIn
  },
  {
    path: "/clinics/digital/select-clinician",
    name: "digitalClinicsSelectClinician",
    component: LoggedIn,
  },
  {
    path: "/clinics/digital",
    name: "digitalClinicsGeneric",
    component: LoggedIn
  },
  {
    path: "/email-browser",
    name: "OpenEmailbrowser",
    component: OpenEmailBrowser
  },
  {
    path: "/faqs",
    name: "faqs",
    component: Faqs
  },
  {
    path: "/wallet",
    name: "wallet",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/coaching-survey",
    name: "coaching-survey",
    component: NotLoggedIn,
  },
  {
    path: "/company-board",
    name: "companyBoard",
    component: LoggedIn,
  },
  {
    path: "/company-board/category/:id",
    name: "companyBoardCategory",
    component: LoggedIn,
  },
  {
    path: "/company-board/:id",
    name: "companyBoardPost",
    component: LoggedIn,
  },
  {
    path: "/womens-day-series",
    name: "womensDaySeries",
    component: LoggedIn,
  },
  {
    path: "/womens-day-series/:id",
    name: "womensDayEvent",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/gp",
    name: "gp",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/gp/select/:appt_type",
    name: "gpSelect",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/my-progress",
    name: "myProgress",
    component: LoggedIn
  },
  {
    path: "/my-list",
    name: "myList",
    component: LoggedIn
  },
  {
    path: "/favourites",
    name: "favourites",
    component: LoggedIn
  },
  {
    path: "/oauth/google/redirect",
    name: "OAuthRedirectGoogle",
    component: LoggedIn
  },
  {
    path: "/customise",
    name: "customise",
    component: LoggedIn
  },
  {
    path: "/custom-content",
    name: 'customContent',
    component: LoggedIn
  },
  {
    path: "/user-management",
    name: 'userManagement',
    component: LoggedIn
  },
  {
    path: "/data-analytics",
    name: 'dataAnalytics',
    component: LoggedIn
  },
  {
    path: "/challenges",
    name: 'challenges',
    component: LoggedIn
  },
  {
    path: "/start",
    name: "start",
    component: LoggedIn
  },
  {
    path: "/password-reset",
    name: "reset",
    component: LoggedIn
  },
  {
    path: "/select/:slug",
    name: "select",
    component: LoggedIn
  },
  {
    path: '/therapy-agreement',
    name: 'therapyAgreement',
    component: LoggedIn
  },
  {
    path: '/therapy-form/:id',
    name: 'therapyForm',
    component: LoggedIn
  },
  {
    path: '/questionnaire/:id',
    name: 'therapyQuestionnaire',
    component: LoggedIn
  },
  {
    path: '/school-questionnaire/:id',
    name: 'schoolQuestionnaire',
    component: TherapySchoolQuestionnaire
  },
  {
    path: '/send-school-questionnaire',
    name: 'sendSchoolQuestionnaire',
    component: LoggedIn
  },
  {
    path: '/cmh',
    name: 'cmh',
    component: LoggedIn
  },
  {
    path: '/service-dashboard/:slug',
    name: 'serviceDashboard',
    component: LoggedIn
  },
  {
    path: '/accessibility-policy',
    name: 'accessibilityPolicy',
    component: AccessibilityPolicy
  },
  {
    path: '/verify-email',
    name: 'emailVerification',
    component: VerifyEmail
  },
  {
    path: '/services',
    name: 'servicesPage',
    component: LoggedIn
  },
  {
    path: '/services/:serviceId',
    name: 'serviceHandoverPage',
    component: LoggedIn
  },
  {
    path: '/articles/:articleId',
    name: 'articlePage',
    component: LoggedIn
  },
  {
    path: "/session-booking",
    name: "sessionBooking",
    component: LoggedIn,
  },
  {
    path: "/transaction-success",
    name: "paymentConfirmation",
    component: LoggedIn,
  },
  {
    path: "/transaction-cancelled",
    name: "transactionCancelled",
    component: LoggedIn,
  },
  {
    path: "/mobile-redirect",
    name: "mobileRedirect",
    component: StripeMobileRedirect
  },
  {
    path: "/mobile-transaction-cancelled",
    name: "mobileTransactionCancelled",
    component: StripeMobileRedirect
  },
  {
    path: "/referral/:code",
    name: "welcomeReferral",
    component: WelcomeReferral
  },
  {
    // Wildcard so the Cara Web SDK's deep links (/cara/onboarding, /cara/chat,
    // /cara/goals, /cara/exercises/:id) and hard refresh all resolve to this route;
    // CaraWeb translates the sub-path to/from the SDK's pathname.
    path: "/cara*",
    name: "cara",
    component: LoggedIn
  },
  {
    path: "/session/:type/:id",
    name: "session",
    component: LoggedIn,
  },
];

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

let brandingLoaded = false;

function setMeta(title, faviconURL) {
  document.title = title;
  const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = faviconURL;
  document.getElementsByTagName("head")[0].appendChild(link);
}

// RTW reminder emails link to the portal root with `?appointmentid=<sf_appointment_id>`
// (core-api EmailContentHelper) rather than the session route, so the member lands on a
// generic home/login screen. Translate it into the deep link: logged out, LoggedIn's
// guard stores the full path and sign-in returns here. `dmh` mirrors AppointmentCard,
// which routes everything except Coaching to the dmh meeting room.
router.beforeEach((to, from, next) => {
  const appointmentId = Array.isArray(to.query.appointmentid)
    ? to.query.appointmentid[0]
    : to.query.appointmentid;
  if (!appointmentId || to.name === "session") {
    next();
    return;
  }
  const remainingQuery = { ...to.query };
  delete remainingQuery.appointmentid;
  next({
    path: `/session/dmh/${appointmentId}`,
    query: remainingQuery,
    replace: true,
  });
});

router.beforeEach(async (to, from, next) => {
  if (!brandingLoaded) {
    brandingLoaded = true;
    const domain = window.location.host.split(".").filter((x) => x !== "www")[0];
    if (domain.includes("laya")) setMeta(domain, "/img/laya-favicon.png");
    if (domain.includes("focusonyou")) setMeta("Focus on You", "/img/favicon.ico");
    if (domain.includes("bupa")) setMeta("Digital GP services | Bupa UK", "/img/bupa-favicon.ico");

    const payload = {};
    const userId = store.getters.user_id;
    if (typeof userId === "string" && userId.length > 0) {
      payload.user_id = userId;
    } else {
      payload.portal_domain = domain;
    }
    store.commit("setDomain", domain);

    try {
      const res = await axios.post(
        config.api_env + "/application/api/customisations/get-client-branding",
        payload,
        config.options
      );
      if (res.data.success) {
        store.commit("setSkin", res.data.skin);
        store.commit("setAccessCode", res.data.access_code);
        store.commit("setClientBranding", res.data);
        store.commit("setNavType", res.data.home_page);
        store.commit("setTwoFactorEnabled", res.data.two_factor_enabled);
        if (to.query.lang) {
          store.commit("setLanguage", to.query.lang);
        } else if (!store.state.user.authenticated) {
          store.commit("setLanguage", res.data.lang);
        }
        if (res.data.skin === 13) {
          setMeta("SanusX", "/img/sanusx/favicon.png");
        }
      } else {
        if (store.getters.hardcoded && store.getters.hardcoded.skin) {
          store.commit("setSkin", store.getters.hardcoded.skin);
        }
        store.commit("setAccessCode", 0);
      }
    } catch (e) {
      // branding fetch failed — continue anyway
    }
  }
  next();
});

if (store.getters.hardcoded && store.getters.hardcoded.permittedRoutes) {
  router.beforeEach((to, from, next) => {
    if (
      !store.getters.hardcoded.permittedRoutes.includes(to.name)
    ) {
      try {
        next(store.getters.homeRoute);
      } catch (e) {
        console.log(e)
        next('/login')
      }
    }
    next();
  });
}
// Gate the V2 (Pulse) Insights flow behind the pulse_insights_v2_enabled admin
// feature flag. The landing pre-loads the flag so ContentRouter renders the
// right page without a flash; the V2-only check-in/report routes redirect to
// the Insights landing (which falls back to legacy) when the flag is off.
router.beforeEach(async (to, from, next) => {
  const insightsRoutes = ["insights", "insightsCheckIn", "insightsReport"];
  if (!insightsRoutes.includes(to.name) || !store.getters.user.authenticated) {
    next();
    return;
  }
  const enabled = await store.dispatch("ensurePulseInsightsV2Flag");
  if (!enabled && to.name !== "insights") {
    next("/personal/insights");
    return;
  }
  next();
});

export default router;
